<div class="container">
  <num-concept
    class="height-100"
    *ngIf="attributeFilter.isConceptSet()"
    [display]="attributeFilter.getDisplay()"
    [conceptFilter]="attributeFilter.getConcept()"
    (changedConceptFilter)="updateConceptFilter($event)"
  ></num-concept>
  <num-quantity
    *ngIf="attributeFilter.getQuantity()"
    (quantityFilterChange)="updateQuantityFilter($event)"
    [quantityFilter]="attributeFilter.getQuantity()"
  ></num-quantity>
</div>
